import UploadPhotos from "./UploadPhotos"
import styles from "./PhotosUploadModal.module.scss"
import { connect } from "react-redux"
import { openIdentityModal, sendIdentityPhotos } from "../../store/actions"
import { useNavigate } from "react-router-dom"
import { motion } from "framer-motion"
import ModalOverlay from "../UI/ModalOverlay/ModalOverlay.tsx"

const isMobile = () => typeof window !== "undefined" && window.innerWidth <= 768

const PhotoUploadModal = ({
  closeModal,
  onSubmit,
  handleSendPhotos,
  identityModal,
  sendIdentityPhotos,
  openIdentityModal,
}) => {
  const navigate = useNavigate()

  const handleSendPhotosFromForm = (files) => {
    const email = identityModal?.emailToValidate
    sendIdentityPhotos(files, email, navigate, identityModal?.source || "workbag")
  }

  const handleCloseModal = () => {
    openIdentityModal(false)
  }

  const sheetVariantsDesktop = {
    hidden: { opacity: 0, scale: 0.96 },
    visible: { opacity: 1, scale: 1, transition: { type: "spring", stiffness: 300, damping: 30 } },
  }

  const sheetVariantsMobile = {
    hidden: { y: "100%" },
    visible: { y: 0, transition: { type: "spring", stiffness: 400, damping: 40 } },
  }

  const sheetVariants = isMobile() ? sheetVariantsMobile : sheetVariantsDesktop

  return (
    <ModalOverlay isOpen onClose={closeModal ? () => closeModal({ reason: "cancel" }) : undefined} zIndex={1000}>
      <motion.div
        className={styles.sheet}
        variants={sheetVariants}
        initial="hidden"
        animate="visible"
      >
        <div className={styles.modalBody}>
          {identityModal?.isOpen ? (
            <UploadPhotos closeModal={handleCloseModal} handleSendPhotos={handleSendPhotosFromForm} />
          ) : (
            <UploadPhotos onSubmit={onSubmit} closeModal={closeModal} handleSendPhotos={handleSendPhotos} />
          )}
        </div>
      </motion.div>
    </ModalOverlay>
  )
}

const mapStateToProps = (state) => {
  return {
    identityModal: state.register.identityModal,
  }
}

export default connect(mapStateToProps, { sendIdentityPhotos, openIdentityModal })(PhotoUploadModal)
